export const noiseConfig = {
  assistantName: "Noise",
  useCaseId: "noise",
  assistantId: process.env.REACT_APP_VAPI_NOISE_ASSISTANT_ID, // Your Noise-specific assistant ID
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized conversations at scale, providing you with deep insights and actionable data—fast.",
  sectionTitle: "Shopify Cart Recovery Agent for Noise",
  sectionDescription:
    "Try how Our voice agent can delight Noise customers and turn them into brand advocates!",
  features: [
    "60% Recovery Rate",
    "100% Automation",
    "Complete Domain Understanding",
    "Call Transcripts & metrics",
    "Easy Integrations",
    "Multilingual support",
  ],
  whyChooseFeatures: [
    {
      icon: "🛒",
      title: "Cart Recovery",
      description:
        "Recover abandoned carts with personalized voice interactions that feel natural and helpful.",
    },
    {
      icon: "⚡",
      title: "Real-time Response",
      description:
        "Instant response to cart abandonment with immediate outreach to customers.",
    },
    {
      icon: "📈",
      title: "Higher Conversion",
      description:
        "Achieve 60% cart recovery rates with AI-powered conversations.",
    },
    {
      icon: "🔊",
      title: "Brand Voice",
      description:
        "Maintain Noise's brand personality in every customer interaction.",
    },
  ],
  seo: {
    title: "Noise Cart Recovery Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent recovers abandoned carts for Noise customers with personalized conversations.",
    canonical: "https://www.beanbag.ai/demo/noise",
    keywords:
      "cart recovery, Shopify automation, voice AI, e-commerce, Noise, abandoned cart recovery",
    ogTitle: "Noise Cart Recovery Demo - Beanbag AI",
    ogDescription:
      "Try how Our voice agent can delight Noise customers and turn them into brand advocates!",
    ogImage: "https://www.beanbag.ai/images/noise-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/noise",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Noise Cart Recovery Agent",
      applicationCategory: "E-commerce Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for recovering abandoned shopping carts for Noise customers.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const lunazoneConfig = {
  assistantName: "Lunazone",
  useCaseId: "lunazone",
  assistantId: process.env.REACT_APP_VAPI_LUNAZONE_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized conversations at scale, providing you with deep insights and actionable data—fast.",
  sectionTitle: "AI Customer Experience Agent for Lunazone",
  sectionDescription:
    "See how our voice agent transforms Lunazone customer interactions into delightful experiences!",
  features: [
    "24/7 Customer Support",
    "Product Recommendations",
    "Order Status Updates",
    "Return & Exchange Assistance",
    "Multi-language Support",
    "Seamless Integration",
  ],
  whyChooseFeatures: [
    {
      icon: "🌙",
      title: "Brand Experience",
      description:
        "Deliver Lunazone's premium brand experience through every voice interaction.",
    },
    {
      icon: "🎯",
      title: "Personalization",
      description:
        "Tailored conversations based on customer history and preferences.",
    },
    {
      icon: "⭐",
      title: "Customer Satisfaction",
      description:
        "Achieve higher customer satisfaction scores with AI-powered support.",
    },
    {
      icon: "🔄",
      title: "Seamless Integration",
      description:
        "Integrates perfectly with Lunazone's existing systems and workflows.",
    },
  ],
  seo: {
    title: "Lunazone Customer Experience Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Lunazone customer interactions with intelligent conversations.",
    canonical: "https://www.beanbag.ai/demo/lunazone",
    keywords:
      "customer experience, voice AI, Lunazone, customer support automation, AI assistant",
    ogTitle: "Lunazone Customer Experience Demo - Beanbag AI",
    ogDescription:
      "See how our voice agent transforms Lunazone customer interactions into delightful experiences!",
    ogImage: "https://www.beanbag.ai/images/lunazone-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/lunazone",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Lunazone Customer Experience Agent",
      applicationCategory: "Customer Service Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for enhancing Lunazone customer experience and support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const hdfcConfig = {
  assistantName: "HDFC Bank",
  useCaseId: "hdfc",
  assistantId: process.env.REACT_APP_VAPI_HDFC_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized banking conversations at scale, providing you with deep insights and actionable customer data—fast.",
  sectionTitle: "AI Banking Assistant for HDFC",
  sectionDescription:
    "Experience how our voice agent transforms HDFC customer banking into seamless, intelligent interactions!",
  features: [
    "24/7 Banking Support",
    "Account Balance Inquiries",
    "Transaction History",
    "Loan Application Assistance",
    "Credit Card Support",
    "Secure Authentication",
  ],
  whyChooseFeatures: [
    {
      icon: "🏦",
      title: "Banking Excellence",
      description:
        "Deliver HDFC's trusted banking experience through intelligent voice interactions.",
    },
    {
      icon: "🔒",
      title: "Secure Transactions",
      description:
        "Bank-grade security with voice biometrics and multi-factor authentication.",
    },
    {
      icon: "⚡",
      title: "Instant Support",
      description:
        "Immediate assistance for account queries, transactions, and banking services.",
    },
    {
      icon: "🎯",
      title: "Personalized Service",
      description:
        "Tailored banking solutions based on customer profile and transaction history.",
    },
  ],
  seo: {
    title: "HDFC Banking Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances HDFC banking services with intelligent, secure conversations.",
    canonical: "https://www.beanbag.ai/demo/hdfc",
    keywords:
      "banking AI, voice banking, HDFC, customer service automation, financial AI assistant, secure banking",
    ogTitle: "HDFC Banking Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms HDFC customer banking into seamless, intelligent interactions!",
    ogImage: "https://www.beanbag.ai/images/hdfc-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/hdfc",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "HDFC Banking Assistant",
      applicationCategory: "Financial Services Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for HDFC banking services, account management, and customer support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const rlthomeConfig = {
  assistantName: "RLTHome",
  useCaseId: "rlthome",
  assistantId: process.env.REACT_APP_VAPI_RLTHOME_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized real estate conversations at scale, providing you with deep insights and actionable property data—fast.",
  sectionTitle: "AI Real Estate Assistant for RLTHome",
  sectionDescription:
    "Experience how our voice agent transforms RLTHome property interactions into seamless, intelligent conversations!",
  features: [
    "24/7 Property Support",
    "Property Recommendations",
    "Virtual Property Tours",
    "Mortgage Assistance",
    "Market Insights",
    "Appointment Scheduling",
  ],
  whyChooseFeatures: [
    {
      icon: "🏠",
      title: "Property Expertise",
      description:
        "Deliver RLTHome's trusted real estate experience through intelligent voice interactions.",
    },
    {
      icon: "🎯",
      title: "Smart Matching",
      description:
        "AI-powered property matching based on customer preferences and budget.",
    },
    {
      icon: "📞",
      title: "Instant Response",
      description:
        "Immediate assistance for property inquiries, viewings, and real estate services.",
    },
    {
      icon: "📈",
      title: "Market Intelligence",
      description:
        "Real-time market data and personalized insights for informed decisions.",
    },
  ],
  seo: {
    title: "RLTHome Real Estate Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances RLTHome real estate services with intelligent, personalized conversations.",
    canonical: "https://www.beanbag.ai/demo/rlthome",
    keywords:
      "real estate AI, property assistant, RLTHome, voice AI, property search, real estate automation",
    ogTitle: "RLTHome Real Estate Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms RLTHome property interactions into seamless, intelligent conversations!",
    ogImage: "https://www.beanbag.ai/images/rlthome-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/rlthome",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "RLTHome Real Estate Assistant",
      applicationCategory: "Real Estate Services Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for RLTHome real estate services, property search, and customer support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const europeConfig = {
  assistantName: "RLTHome",
  useCaseId: "europe",
  assistantId: process.env.REACT_APP_VAPI_EUROPE_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized real estate conversations at scale, providing you with deep insights and actionable property data—fast.",
  sectionTitle: "AI Real Estate Assistant for RLTHome",
  sectionDescription:
    "Experience how our voice agent transforms RLTHome property interactions into seamless, intelligent conversations!",
  features: [
    "24/7 Property Support",
    "Property Recommendations",
    "Virtual Property Tours",
    "Mortgage Assistance",
    "Market Insights",
    "Appointment Scheduling",
  ],
  whyChooseFeatures: [
    {
      icon: "🏠",
      title: "Property Expertise",
      description:
        "Deliver RLTHome's trusted real estate experience through intelligent voice interactions.",
    },
    {
      icon: "🎯",
      title: "Smart Matching",
      description:
        "AI-powered property matching based on customer preferences and budget.",
    },
    {
      icon: "📞",
      title: "Instant Response",
      description:
        "Immediate assistance for property inquiries, viewings, and real estate services.",
    },
    {
      icon: "📈",
      title: "Market Intelligence",
      description:
        "Real-time market data and personalized insights for informed decisions.",
    },
  ],
  micText: "Talk to Agent in German",
  seo: {
    title: "RLTHome Real Estate Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances RLTHome real estate services with intelligent, personalized conversations.",
    canonical: "https://www.beanbag.ai/demo/europe",
    keywords:
      "real estate AI, property assistant, RLTHome, voice AI, property search, real estate automation",
    ogTitle: "RLTHome Real Estate Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms RLTHome property interactions into seamless, intelligent conversations!",
    ogImage: "https://www.beanbag.ai/images/rlthome-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/europe",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "RLTHome Real Estate Assistant",
      applicationCategory: "Real Estate Services Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for RLTHome real estate services, property search, and customer support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const cradlewiseConfig = {
  assistantName: "Cradlewise",
  useCaseId: "cradlewise",
  assistantId: process.env.REACT_APP_VAPI_CRADLEWISE_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional customer support with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized parent conversations at scale, providing you with deep insights about your baby's sleep patterns and actionable support—fast.",
  sectionTitle: "AI Parent Support Agent for Cradlewise",
  sectionDescription:
    "Experience how our voice agent transforms Cradlewise customer support into personalized, intelligent conversations for better baby sleep!",
  features: [
    "24/7 Sleep Support",
    "Product Setup Assistance",
    "Sleep Pattern Analysis",
    "Troubleshooting Help",
    "Personalized Sleep Tips",
    "Order & Warranty Support",
  ],
  whyChooseFeatures: [
    {
      icon: "🍼",
      title: "Baby Sleep Expertise",
      description:
        "Specialized knowledge about smart cribs, sleep patterns, and baby development milestones.",
    },
    {
      icon: "🌙",
      title: "24/7 Parent Support",
      description:
        "Round-the-clock assistance for sleep emergencies and product questions when parents need it most.",
    },
    {
      icon: "📱",
      title: "Smart Integration",
      description:
        "Seamlessly connects with Cradlewise app data to provide personalized sleep insights and recommendations.",
    },
    {
      icon: "👨‍👩‍👧‍👦",
      title: "Family-Focused",
      description:
        "Understanding that every family's sleep journey is unique, with tailored advice for each baby's needs.",
    },
  ],
  seo: {
    title: "Cradlewise Parent Support Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Cradlewise customer support with intelligent, personalized conversations for better baby sleep.",
    canonical: "https://www.beanbag.ai/demo/cradlewise",
    keywords:
      "baby sleep AI, smart crib support, Cradlewise, parenting assistant, voice AI, baby monitor support, sleep consultation",
    ogTitle: "Cradlewise Parent Support Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Cradlewise customer support into personalized, intelligent conversations for better baby sleep!",
    ogImage: "https://www.beanbag.ai/images/cradlewise-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/cradlewise",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Cradlewise Parent Support Agent",
      applicationCategory: "Parenting & Baby Care Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Cradlewise customer support, sleep consultation, and smart crib assistance.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const zoomcarConfig = {
  assistantName: "Zoomcar",
  useCaseId: "zoomcar",
  assistantId: process.env.REACT_APP_VAPI_ZOOMCAR_ASSISTANT_ID,
  heroDescription:
    "Meet your AI-powered travel companion for smarter car rentals. From booking to roadside support, our voice agent delivers quick, reliable, and personalized assistance—so every trip with Zoomcar is stress-free and enjoyable.",
  sectionTitle: "AI Car Rental Assistant for Zoomcar",
  sectionDescription:
    "Experience how our voice agent transforms Zoomcar bookings into seamless, intelligent conversations for hassle-free car rentals!",
  features: [
    "Instant Booking Assistance",
    "24/7 Customer Support",
    "Real-time Car Availability",
    "Trip Planning Support",
    "Damage & Insurance Claims",
    "Multilingual Support",
  ],
  whyChooseFeatures: [
    {
      icon: "🚗",
      title: "Smart Car Matching",
      description:
        "AI-powered car recommendations based on your trip requirements, budget, and preferences.",
    },
    {
      icon: "⚡",
      title: "Instant Booking",
      description:
        "Complete car bookings in minutes with voice-guided assistance and real-time availability.",
    },
    {
      icon: "🗺️",
      title: "Trip Planning",
      description:
        "Get personalized route suggestions, fuel estimates, and local insights for your journey.",
    },
    {
      icon: "🛡️",
      title: "24/7 Roadside Support",
      description:
        "Immediate assistance for breakdowns, accidents, or any road emergencies during your trip.",
    },
  ],
  seo: {
    title: "Zoomcar Car Rental Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Zoomcar car rental services with intelligent, personalized booking conversations.",
    canonical: "https://www.beanbag.ai/demo/zoomcar",
    keywords:
      "car rental AI, Zoomcar, voice booking, travel assistant, car sharing automation, rental support, trip planning AI",
    ogTitle: "Zoomcar Car Rental Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Zoomcar bookings into seamless, intelligent conversations for hassle-free car rentals!",
    ogImage: "https://www.beanbag.ai/images/zoomcar-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/zoomcar",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Zoomcar Car Rental Assistant",
      applicationCategory: "Travel & Transportation Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Zoomcar car rental bookings, customer support, and trip assistance.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const generalConfig = {
  assistantName: "customer-agent",
  useCaseId: "customer-agent",
  assistantId: "",
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional car rental methods with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized booking conversations at scale, providing you with seamless car rental experiences and actionable travel insights—fast.",
  sectionTitle: "AI Car Rental Assistant for Zoomcar",
  sectionDescription:
    "Experience how our voice agent transforms Zoomcar bookings into seamless, intelligent conversations for hassle-free car rentals!",
  features: [
    "Instant Booking Assistance",
    "24/7 Customer Support",
    "Real-time Car Availability",
    "Trip Planning Support",
    "Damage & Insurance Claims",
    "Multilingual Support",
  ],
  whyChooseFeatures: [
    {
      icon: "🚗",
      title: "Smart Car Matching",
      description:
        "AI-powered car recommendations based on your trip requirements, budget, and preferences.",
    },
    {
      icon: "⚡",
      title: "Instant Booking",
      description:
        "Complete car bookings in minutes with voice-guided assistance and real-time availability.",
    },
    {
      icon: "🗺️",
      title: "Trip Planning",
      description:
        "Get personalized route suggestions, fuel estimates, and local insights for your journey.",
    },
    {
      icon: "🛡️",
      title: "24/7 Roadside Support",
      description:
        "Immediate assistance for breakdowns, accidents, or any road emergencies during your trip.",
    },
  ],
  seo: {
    title: "Zoomcar Car Rental Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Zoomcar car rental services with intelligent, personalized booking conversations.",
    canonical: "https://www.beanbag.ai/demo/zoomcar",
    keywords:
      "car rental AI, Zoomcar, voice booking, travel assistant, car sharing automation, rental support, trip planning AI",
    ogTitle: "Zoomcar Car Rental Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Zoomcar bookings into seamless, intelligent conversations for hassle-free car rentals!",
    ogImage: "https://www.beanbag.ai/images/zoomcar-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/zoomcar",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Zoomcar Car Rental Assistant",
      applicationCategory: "Travel & Transportation Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Zoomcar car rental bookings, customer support, and trip assistance.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const epikConfig = {
  assistantName: "Epik",
  useCaseId: "epik",
  assistantId: process.env.REACT_APP_VAPI_EPIK_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it is an intelligent, voice-moderated interaction to improve customer retention. Our AI voice agent conducts personalized conversations at scale, providing you with deep insights and actionable digital presence data- fast.",
  sectionTitle: "AI Domain & Web Services Assistant for Epik",
  sectionDescription:
    "Experience how our voice agent helps Customers navigate booking demos for electronic products of their choice on Epik to make a better, smarter purchasing decision!",
  features: [
    "Domain Search & Registration",
    "24/7 Technical Support",
    "DNS Management Assistance",
    "Web Hosting Support",
    "SSL Certificate Setup",
    "Domain Transfer Guidance",
  ],
  whyChooseFeatures: [
    {
      icon: "🌐",
      title: "Domain Expertise",
      description:
        "Intelligent domain recommendations based on your business needs, brand goals, and market trends.",
    },
    {
      icon: "⚡",
      title: "Instant Setup",
      description:
        "Complete domain registration and web service setup in minutes with voice-guided assistance.",
    },
    {
      icon: "🔒",
      title: "Security First",
      description:
        "Advanced security features, SSL management, and protection services for your digital assets.",
    },
    {
      icon: "🎯",
      title: "Business Growth",
      description:
        "Strategic advice on domain portfolio management and digital brand expansion opportunities.",
    },
  ],
  seo: {
    title: "Epik Domain Services Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Epik domain and web services with intelligent, personalized conversations.",
    canonical: "https://www.beanbag.ai/demo/epik",
    keywords:
      "domain registration AI, Epik, voice assistant, web services automation, domain management, DNS support, digital presence AI",
    ogTitle: "Epik Domain Services Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Epik domain management into seamless, intelligent conversations for your digital success!",
    ogImage: "https://www.beanbag.ai/images/epik-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/epik",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Epik Domain Services Assistant",
      applicationCategory: "Web Services Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Epik domain registration, web hosting, and digital services support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const magicleafConfig = {
  assistantName: "Magic Leaf",
  useCaseId: "magicleaf",
  assistantId: process.env.REACT_APP_VAPI_MAGICLEAF_ASSISTANT_ID,
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional health product consultations with intelligent, voice-moderated interactions. Our AI voice agent conducts personalized health conversations at scale, providing you with deep insights about natural sweeteners and actionable wellness guidance—fast.",
  sectionTitle: "AI Health & Wellness Assistant for Magic Leaf",
  sectionDescription:
    "Experience how our voice agent transforms Magic Leaf customer interactions into personalized, intelligent conversations for healthier lifestyle choices!",
  features: [
    "Product Recommendations",
    "Diabetic-Friendly Solutions",
    "24/7 Health Support",
    "Recipe & Usage Guidance",
    "Nutritional Information",
    "Order & Delivery Support",
  ],
  whyChooseFeatures: [
    {
      icon: "🌿",
      title: "Natural Wellness",
      description:
        "Expert guidance on Himalayan stevia products and natural sugar alternatives for healthier living.",
    },
    {
      icon: "💚",
      title: "Diabetic Support",
      description:
        "Specialized assistance for diabetic customers with zero-calorie, blood sugar-friendly product recommendations.",
    },
    {
      icon: "🍯",
      title: "Smart Substitution",
      description:
        "AI-powered advice on replacing sugar in recipes, desserts, and daily beverages with Magic Leaf products.",
    },
    {
      icon: "📋",
      title: "Health Insights",
      description:
        "Personalized nutritional guidance and wellness tips based on your health goals and dietary preferences.",
    },
  ],
  seo: {
    title: "Magic Leaf Health Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent enhances Magic Leaf customer support with intelligent, personalized health and wellness conversations.",
    canonical: "https://www.beanbag.ai/demo/magicleaf",
    keywords:
      "natural sweetener AI, Magic Leaf, health assistant, stevia products, diabetic support, sugar-free lifestyle, wellness automation, voice health consultant",
    ogTitle: "Magic Leaf Health Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Magic Leaf customer interactions into personalized, intelligent conversations for healthier lifestyle choices!",
    ogImage: "https://www.beanbag.ai/images/magicleaf-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/magicleaf",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Magic Leaf Health Assistant",
      applicationCategory: "Health & Wellness Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Magic Leaf natural sweetener products, health consultation, and wellness support.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};

export const haflaConfig = {
  assistantName: "Hafla",
  useCaseId: "hafla",
  assistantId: process.env.REACT_APP_VAPI_HAFLA_ASSISTANT_ID,
  heroTitle: "Transform event inquiries into bookings for Hafla",
  heroDescription:
    "It is more than just an AI voice agent—it replaces traditional sales calls with intelligent, consultative conversations. Our AI voice agent handles customer inquiries at scale, gathering detailed event requirements, presenting tailored packages, and creating instant budget estimates, turning every call into a qualified lead ready for conversion.",
  sectionTitle: "AI Event Planning Assistant for Hafla",
  sectionDescription:
    "Experience how our voice agent transforms Hafla event inquiries into seamless bookings with intelligent, personalized conversations!",
  features: [
    "Event Requirement Gathering",
    "Instant Budget Estimates",
    "Venue Recommendations",
    "Package Customization",
    "24/7 Inquiry Handling",
    "Lead Qualification",
  ],
  whyChooseFeatures: [
    {
      icon: "🎉",
      title: "Event Expertise",
      description:
        "From corporate events to weddings, our AI understands every detail needed to plan perfect celebrations.",
    },
    {
      icon: "💰",
      title: "Instant Quotes",
      description:
        "Generate accurate budget estimates in real-time based on event requirements and package selections.",
    },
    {
      icon: "🎯",
      title: "Smart Matching",
      description:
        "AI-powered recommendations for venues, vendors, and packages tailored to client preferences and budget.",
    },
    {
      icon: "📞",
      title: "24/7 Availability",
      description:
        "Never miss an inquiry. Handle customer calls round-the-clock and convert them into qualified leads.",
    },
  ],
  seo: {
    title: "Hafla Event Planning Assistant Demo - Beanbag AI",
    description:
      "Experience how our voice AI agent transforms Hafla event inquiries into bookings with intelligent, consultative conversations.",
    canonical: "https://www.beanbag.ai/demo/hafla",
    keywords:
      "event planning AI, Hafla, voice assistant, event booking automation, venue recommendations, wedding planning AI, corporate events automation",
    ogTitle: "Hafla Event Planning Assistant Demo - Beanbag AI",
    ogDescription:
      "Experience how our voice agent transforms Hafla event inquiries into seamless bookings with intelligent, personalized conversations!",
    ogImage: "https://www.beanbag.ai/images/hafla-demo-card.jpg",
    ogUrl: "https://www.beanbag.ai/demo/hafla",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Hafla Event Planning Assistant",
      applicationCategory: "Event Planning & Management Automation",
      operatingSystem: "Web",
      description:
        "AI-powered voice agent for Hafla event planning, venue booking, and customer inquiry management.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    },
  },
};
